function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M4 2.5a1.5 1.5 0 11-3.001-.001A1.5 1.5 0 014 2.5h0zm0 5a1.5 1.5 0 11-3.001-.001A1.5 1.5 0 014 7.5h0zm0 5a1.5 1.5 0 11-3.001-.001A1.5 1.5 0 014 12.5h0z",
  stroke: "#FFF",
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgMenuMore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 15
  }, props), _ref);
}

export default SvgMenuMore;